import { useEffect } from 'react'

import useSignOut from '~/features/auth/hooks/useSignOut'
import { EClientPath, EMarketingClientPath } from '~/models/api'
import HttpService from '~/services/http'
import { store } from '~/store'

const useAxiosInterceptors = () => {
  const { signOut } = useSignOut()
  const setUser = store((state) => state.setUser)

  useEffect(() => {
    HttpService.getAllAvailableInterceptors().then((interceptors) => {
      if (!interceptors) {
        return
      }

      interceptors.map((interceptor) =>
        interceptor.response.use(
          (response) => {
            return response
          },
          (error) => {
            if (error.response.status === 401) {
              if (
                !(
                  [
                    EClientPath.partnerAuth,
                    EMarketingClientPath.home,
                  ] as string[]
                ).includes(window.location.pathname)
              ) {
                setUser({
                  signInRedirectPath: window.location.pathname as EClientPath,
                })
              }
              return signOut().then(() => {
                console.log('401. rejected by axios interceptor')
                return Promise.reject(error)
              })
            }

            console.log('rejected by axios interceptor')
            return Promise.reject(error)
          },
        ),
      )
    })
  }, [setUser, signOut])
}

export default useAxiosInterceptors
